import { BaseModel } from "@/models/base.model"
import { type IKnownBusinessEntityRentalDispenseItem } from "@/interfaces/api/known-business-entity-rental-dispense-item.interface.ts"

export class KnownBusinessEntityRentalDispenseItem
  extends BaseModel
  implements IKnownBusinessEntityRentalDispenseItem
{
  public static readonly className = "KnownBusinessEntityRentalDispenseItem"
  public static readonly verboseName = "bedrijfsverhuurafspraak"

  knownBusinessEntity: string
  rentalDispenseItem: string

  unitPricePerDay: string

  constructor(knownBusinessEntityRentalIntakeItem: IKnownBusinessEntityRentalDispenseItem) {
    super(knownBusinessEntityRentalIntakeItem)

    this.knownBusinessEntity = knownBusinessEntityRentalIntakeItem.knownBusinessEntity
    this.rentalDispenseItem = knownBusinessEntityRentalIntakeItem.rentalDispenseItem

    this.unitPricePerDay = knownBusinessEntityRentalIntakeItem.unitPricePerDay
  }
}
